import React from "react";
import { IonGrid, IonRow, IonCol, isPlatform } from "@ionic/react";
import "./CommodityTitle.scss";
import i18n from "i18n";

export default () => {
  const isMobile = isPlatform("mobile") || isPlatform("mobileweb");
  const paddingClass = isMobile ? "mobile-padding" : "web-padding";

  return (
    <IonGrid className="commodity-title-component" data-testid="iongrid">
      <IonRow data-testid="ionrow">
        <IonCol data-testid="description" className={paddingClass}>
          {i18n.t("Description")}
        </IonCol>
        <IonCol data-testid="packaging-type" className={paddingClass}>
          {i18n.t("Packaging Type")}
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};
